import React, { useCallback, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { ProgressButton } from 'modules/common';
import { useSessionContext } from 'modules/session';
import { useNotesBackgroudTimer } from '../hooks/useNotesBackgroudTimer';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0)
  },
  title: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.spacing(2.5),
    lineHeight: 1.6,
    fontFamily: theme.typography.h6.fontFamily
  },
  messages: {
    color: theme.palette.text.primary
  },
  actionsWrapper: {
    padding: theme.spacing(2),
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  }
}));

function LogoutDialog({
  closeDrawer,
  open
}: {
  closeDrawer: () => void;
  open: boolean;
}) {
  const [loading, setLoading] = useState(false);
  const { onStop } = useNotesBackgroudTimer();
  const { logout } = useSessionContext();
  const classes = useStyles();

  const handleConfirmClick = useCallback(async () => {
    try {
      setLoading(true);
      await onStop();
      logout();
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }, [onStop, logout]);

  if (!open) return null;

  return (
    <Dialog
      data-testid="background-timer-dialog"
      open={open}
      onClose={closeDrawer}
      className={classes.root}
    >
      <DialogTitle className={classes.title}>
        <FormattedMessage id="note.inlineTimer.logoutBanner.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.messages}>
          <FormattedMessage id="note.inlineTimer.logoutBanner.content" />
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actionsWrapper}>
        <Button
          data-testid="background-timer-dialog-btn-1"
          variant="text"
          onClick={closeDrawer}
        >
          <Typography color="textSecondary">
            <FormattedMessage id="note.inlineTimer.logoutBanner.actionButton.secondary" />
          </Typography>
        </Button>
        <ProgressButton
          data-testid="background-timer-dialog-btn-2"
          variant="contained"
          loading={loading}
          onClick={handleConfirmClick}
        >
          <FormattedMessage id="note.inlineTimer.logoutBanner.actionButton.primary" />
        </ProgressButton>
      </DialogActions>
    </Dialog>
  );
}

export default LogoutDialog;
